import { useNavigate, useParams } from 'react-router-dom';
import { useReel } from '../api/hooks';
import { formatCount, formatWhen } from '../lib/format';
import { ErrorView, HistoryButton, Loading, Screen } from '../ui/Screen';
import { Stepper } from '../ui/Stepper';

export function StatsScreen() {
  const { reelId = '' } = useParams();
  const navigate = useNavigate();
  const q = useReel(reelId);

  if (q.isError) return <ErrorView back="/" error={q.error} />;
  if (q.isPending) return <Loading />;
  const { reel } = q.data;
  const m = reel.metrics;
  const kpis = m
    ? [
        ['Views', formatCount(m.views)],
        ['Reach', formatCount(m.reach)],
        ['Avg watched', `${Math.round(m.avgWatchPct)}%`],
        ['Saves', formatCount(m.saves)],
      ]
    : [];

  return (
    <Screen
      title={reel.title}
      back="/"
      right={<HistoryButton reelId={reelId} />}
      bar={
        <button type="button" className="btn" onClick={() => navigate('/')}>
          All reels
        </button>
      }
    >
      <Stepper reel={reel} current="stats" />
      {reel.post ? (
        <span className="nums">
          Live on Instagram{m ? ` · updated ${formatWhen(m.updatedAt)}` : ''}
          {reel.post.url && (
            <>
              {' · '}
              <a href={reel.post.url} target="_blank" rel="noreferrer">
                Open
              </a>
            </>
          )}
        </span>
      ) : (
        <p className="muted">Not posted yet.</p>
      )}
      {m ? (
        <dl className="kpis" style={{ margin: 0 }}>
          {kpis.map(([label, value]) => (
            <div className="kpi" key={label}>
              <dt className="label">{label}</dt>
              <dd style={{ margin: 0 }}>
                <strong>{value}</strong>
              </dd>
            </div>
          ))}
        </dl>
      ) : (
        reel.post && <p className="muted">Numbers arrive within a day after posting.</p>
      )}
    </Screen>
  );
}
